import { render, staticRenderFns } from "./nxwl-ref.vue?vue&type=template&id=76b8ced9"
import script from "./nxwl-ref.vue?vue&type=script&lang=js"
export * from "./nxwl-ref.vue?vue&type=script&lang=js"
import style0 from "./nxwl-ref.vue?vue&type=style&index=0&id=76b8ced9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports